/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_Default_ReverseInputs */



/**
* | output |
* | --- |
* | "Default Reverse" |
*
* @param {Workspace_Default_ReverseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_default_reverse = /** @type {((inputs?: Workspace_Default_ReverseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Default_ReverseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par défaut inversé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardmäßig umgekehrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inversione predefinita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратный по умолчанию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inversión predeterminada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("默认反向")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デフォルトリバース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिफ़ॉल्ट रिवर्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reverso padrão")
	return /** @type {LocalizedString} */ ("Default Reverse")
});